export const DemandStatus = {
  DRAFT: "draft", // 草稿
  PENDING: "pending", // 待审核
  // PUBLISHED : 'published', // 已发布
  REJECTED: "rejected", // 已拒绝
  APPROVED: "approved", // 已拒绝
  // BIDDING: "bidding", // 竞标中
  DOWN: "down", //下架
  SELECTED: "selected", // 进行中
  CLOSED: "closed", // 已关闭
  COMPLETED: "completed", // 已完成
  CANCELLED: "cancelled" // 已取消
}
